<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Edição de material' : 'Cadastro de material'">
            <template v-slot:actions>
                <rkm-button
                    @click="exit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @saved="saved"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/web-service/almoxarifado/cliente/material/Form'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {Form},
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        saved() {
            this.unsetShowExitFormConfirmation()
            this.exit()
        },
        exit() {
            this.$router.push('/web-service/almoxarifado-cliente-material/index')
        },
    },
    props: {
        id: {type: Number, default: null}
    },
}
</script>